import { Lecture as ILecture } from "@/api/models/lecture";
import { LecturePageEdit as ILecturePageEdit } from "@/api/models/lecture-page-edit";
import { LecturePageCreate as ILecturePageCreate } from "@/api/models/lecture-page-create";
import { Sort as ISort } from "@/api/models/sort";
import api from "@/getinfo-api";

export interface IEditPageParams {
  lectureId: string;
  pageId: string;
  body: ILecturePageEdit;
}

export interface IPageSort {
  lectureId: string;
  pages: Array<ISort>;
}

export interface IAddPageParams {
  lectureId: string;
  body: ILecturePageCreate;
}

export interface IDeleteLecturePage {
  lectureId: string;
  lecturePage: string;
}

export interface IGetLecturePage {
  lectureId: string;
  lecturePageId: string;
}

export default {
  state: {
    lecture: {}
  },
  actions: {
    GET_LECTURE(ctx: any, lectureId: string): any {
      api.LectureApi.get(lectureId).then((res: { data: ILecture }) => {
        ctx.commit("SETUP_LECTURE", res.data);
      });
    },
    EDIT_LECTURE_PAGE(ctx: any, params: IEditPageParams): any {
      api.LecturePageApi.edit(
        params.lectureId,
        params.pageId,
        params.body
      ).then(() => {
        ctx.dispatch("GET_LECTURE", params.lectureId);
      });
    },
    GET_LECTURE_PAGE(ctx: any, params: IGetLecturePage) {
      return api.LecturePageApi.get(params.lectureId, params.lecturePageId);
    },
    ADD_LECTURE_PAGE(ctx: any, params: IAddPageParams) {
      api.LecturePageApi.create(params.lectureId, params.body).then(() => {
        ctx.dispatch("GET_LECTURE", params.lectureId);
      });
    },
    DELETE_LECTURE_PAGE(ctx: any, params: IDeleteLecturePage) {
      api.LecturePageApi._delete(params.lectureId, params.lecturePage).then(
        () => {
          ctx.dispatch("GET_LECTURE", params.lectureId);
        }
      );
    },
    APPLY_PAGES_SORT(ctx: any, params: IPageSort) {
      api.LecturePageApi.sort(params.lectureId, params.pages).then(() => {
        ctx.dispatch("GET_LECTURE", params.lectureId);
      });
    }
  },
  mutations: {
    SETUP_LECTURE(state: any, lecture: ILecture) {
      state.lecture = lecture;
    }
  },
  getters: {
    SELECTED_LECTURE(state: any) {
      return state.lecture;
    },
    LECTURE_PAGES(state: any) {
      return state.lecture.pages;
    },
    LECTURE_SLIDES(state: any) {
      return state.lecture.slides;
    }
  }
};
